import { css } from 'styled-components'

/**
 * The card face is a premium credential-less art SVG with the PAN/expiry/holder
 * drawn on top in real-card order (number → expiry → name, bottom-left), clear
 * of the printed chip and network mark. The white text + shadows here are
 * intrinsic to the card art, not theme surfaces, so they are literal rather than
 * tokenized — the same latitude the legacy CreditCardDisplay uses.
 */

const CARD_WIDTH = 300

export const card = css`
  position: relative;
  width: ${CARD_WIDTH}px;
  max-width: 100%;
  aspect-ratio: 1.586 / 1;
  flex: 0 0 auto;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 11px 26px rgba(20, 20, 43, 0.11);
`

export const face = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const credentials = css`
  position: absolute;
  left: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const pan = css`
  font-family: 'SF Mono', ui-monospace, Menlo, monospace;
  color: rgba(255, 255, 255, 0.95);
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.06em;
  font-variant-numeric: tabular-nums;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  white-space: pre;
`

export const exp = css`
  font-family: 'SF Mono', ui-monospace, Menlo, monospace;
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.04em;
  font-variant-numeric: tabular-nums;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
`

export const holder = css`
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  line-height: 17px;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
`

const overlayBase = css`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;

  /* backdrop-blur is decorative; the state is also carried in text + the pill */
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`

export const overlayFrozen = css`
  ${overlayBase};
  background: linear-gradient(
    135deg,
    rgba(20, 42, 80, 0.6),
    rgba(10, 24, 50, 0.66)
  );
`

export const overlayLocked = css`
  ${overlayBase};
  background: linear-gradient(
    135deg,
    rgba(34, 30, 40, 0.62),
    rgba(13, 12, 18, 0.7)
  );
`
